import { useCallback } from 'react';
import cn from 'clsx';

import PollListCard, { PollListCardProps } from './Card';
import { FormattedPoll } from '@utils/Poll';

export interface PollListProps
  extends Omit<React.ComponentPropsWithoutRef<'div'>, 'onSelect'>,
    Pick<PollListCardProps, 'accessory' | 'type'> {
  data?: FormattedPoll[];
  isIdea?: boolean;
  loading?: boolean;
  duplicate?: any;
  onSelect?: (poll: FormattedPoll) => void;
}

const PollList: React.FC<PollListProps> = ({
  data,
  loading = false,
  onSelect,
  isIdea = false,
  accessory,
  duplicate = false,
  type,
  className,
  ...props
}) => {
  const onRowClick = useCallback(
    (poll) => {
      onSelect?.(poll);
    },
    [onSelect]
  );

  const rootCn = cn('flex flex-col space-y-3', className);

  return (
    <div className={rootCn} {...props}>
      {data?.map((poll, i) => {
        return (
          <PollListCard
            key={poll.id}
            index={i}
            isIdea={isIdea}
            poll={poll}
            duplicate={duplicate}
            onClick={() => onRowClick(poll)}
            accessory={accessory}
            type={type}
          />
        );
      })}
    </div>
  );
};

export default PollList;
